export default "__VITE_ASSET__Dz2$dv5h__"